import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import moment from 'moment'
import { IntlProvider, addLocaleData } from 'react-intl'

import { LocaleProvider } from 'antd'

// Ant.design locales
import antd_FR from 'antd/lib/locale-provider/fr_BE'
import antd_NL from 'antd/lib/locale-provider/nl_BE'
import antd_EN from 'antd/lib/locale-provider/en_GB'

// Intl locales
import intl_FR from 'react-intl/locale-data/fr';
import intl_NL from 'react-intl/locale-data/nl';
import intl_EN from 'react-intl/locale-data/en';

// App locales
import mess_FR from '../locales/fr'
import mess_NL from '../locales/nl'
import mess_EN from '../locales/en'

// Moment locales
import 'moment/locale/fr'
import 'moment/locale/nl'



// Locales mapping to access them
const locales = {
    fr: { antd: antd_FR, messages: mess_FR, moment: 'fr' },
    nl: { antd: antd_NL, messages: mess_NL, moment: 'nl' },
    en: { antd: antd_EN, messages: mess_EN, moment: 'en' }
}

// Add locales to intl
addLocaleData([...intl_FR, ...intl_NL, ...intl_EN]);



/**
 * I18nProvider
 */

class I18nProvider extends Component {

    static propTypes = {
        session: PropTypes.object.isRequired
    }

    render() {
        let locale = 'fr'
        if (this.props.session.user) {
            locale = this.props.session.user.language
        } else if (this.props.session.language) {
            locale = this.props.session.language
        }
        moment.locale(locales[locale].moment)
        return (
            <LocaleProvider locale={locales[locale].antd}>
                <IntlProvider locale={locale} messages={locales[locale].messages} defaultLocale="fr">
                    <div>
                        {this.props.children}
                    </div>
                </IntlProvider>
            </LocaleProvider>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    session: state.session
})

export default connect(mapStateToProps)(I18nProvider)


// WEBPACK FOOTER //
// ./src/containers/I18nProvider.js